import theme from "../Client/theme";

// A custom theme for this app
// const theme = createMuiTheme({
//     palette: { type: "light" },
// });

export default theme;
